import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';
import { getFunctions, httpsCallable } from 'firebase/functions';

export interface WaitlistFormData {
  firstName: string;
  lastName: string;
  email: string;
  companyName: string;
  companySize: string;
  taxSoftware: string[];
  numberOfReturns: string;
  cardNumber?: string;
  cardExpiry?: string;
  cardCvc?: string;
  cardName?: string;
  hasPaymentInfo: boolean;
}

/**
 * Submits waitlist form data to Firestore and triggers email confirmation
 * @param formData The waitlist form data to submit
 * @returns Promise with the document reference
 */
export const submitWaitlistForm = async (formData: WaitlistFormData): Promise<string> => {
  try {
    // Remove sensitive card data before storing
    const { cardNumber, cardExpiry, cardCvc, cardName, ...safeData } = formData;
    
    // Only store the last 4 digits of the card if provided
    const dataToStore = {
      ...safeData,
      cardLastFour: cardNumber ? cardNumber.slice(-4) : null,
      hasPaymentMethod: !!cardNumber,
      createdAt: serverTimestamp(),
    };
    
    // Add to Firestore
    const docRef = await addDoc(collection(db, 'waitlist'), dataToStore);
    const documentId = docRef.id;
    
    // Trigger the email confirmation function
    try {
      const functions = getFunctions();
      const sendWaitlistEmailFn = httpsCallable(functions, 'sendWaitlistEmail');
      
      // Call the function with the required data
      await sendWaitlistEmailFn({
        email: formData.email,
        firstName: formData.firstName,
        documentId: documentId
      });
      
      console.log('Confirmation email sent successfully');
    } catch (emailError) {
      // Log the error but don't fail the overall submission
      console.error('Error sending confirmation email:', emailError);
    }
    
    return documentId;
  } catch (error) {
    console.error('Error submitting waitlist form:', error);
    throw error;
  }
};
